import {useState} from "react";
import {useTranslation} from "react-i18next";

const SearchBar = ({SetFilter}) => {
  const [searchValue, setsearchValue] = useState("");
  const {t} = useTranslation();

  const submitSearch = () => {
    SetFilter((previous) => ({
      ...previous,
      search: searchValue.trim(),
    }));
  };

  return (
    <form
      className="flex flex-grow items-center gap-2 rounded-[28px] bg-white !p-3 text-sm text-[#7E7E7E]"
      role="search"
      onSubmit={(event) => {
        event.preventDefault();
        submitSearch();
      }}
    >
      <i className="!ml-2 fi fi-rr-search flex justify-center items-center"></i>
      <input
        className="border-none flex-grow w-[90%] placeholder:text-[#7E7E7E] placeholder:truncate placeholder:text-[13px] "
        type="text"
        placeholder={t("searchOfferPlaceholder")}
        value={searchValue}
        onChange={(e) => setsearchValue(e.target.value)}
        aria-label={t("searchOffer")}
      />
      {!!searchValue && (
        <i
          className="fi fi-rr-cross-small flex items-center cursor-pointer"
          onClick={() => {
            setsearchValue("");
            SetFilter((prevFilter) => ({
              ...prevFilter,
              search: "",
            }));
          }}
        ></i>
      )}
      <button type="submit" className="sr-only">
        {t("search")}
      </button>
    </form>
  );
};

export default SearchBar;
